__turbopack_context__.v({
  "caption": "recipe-image-module__0u3zla__caption",
  "image": "recipe-image-module__0u3zla__image",
  "image-fade-in": "recipe-image-module__0u3zla__image-fade-in",
  "imageArrived": "recipe-image-module__0u3zla__imageArrived",
  "overlayCaption": "recipe-image-module__0u3zla__overlayCaption",
  "pendingOverlay": "recipe-image-module__0u3zla__pendingOverlay",
  "placeholder": "recipe-image-module__0u3zla__placeholder",
  "placeholderIconLg": "recipe-image-module__0u3zla__placeholderIconLg",
  "placeholderIconSm": "recipe-image-module__0u3zla__placeholderIconSm",
  "spin": "recipe-image-module__0u3zla__spin",
  "spinner": "recipe-image-module__0u3zla__spinner",
  "spinnerLg": "recipe-image-module__0u3zla__spinnerLg",
  "spinnerSm": "recipe-image-module__0u3zla__spinnerSm",
  "srOnly": "recipe-image-module__0u3zla__srOnly",
});
